export default "__VITE_ASSET__f899446c__"